import FourOhFour from './four-oh-four';
export { FourOhFour };
